import { Command as CmdKPrimitive } from 'cmdk';
import React from 'react';
import sharedStyles from '../radix-floating-elements.module.scss';
import styles from './CmdK.module.scss';

type CommandProps = typeof CmdKPrimitive;

const CmdItem = React.forwardRef<
  HTMLDivElement,
  React.ComponentPropsWithoutRef<typeof CmdKPrimitive.Item>
>((props, forwardedRef) => (
  <CmdKPrimitive.Item className={sharedStyles.dropdownMenuItemBase} {...props} ref={forwardedRef} />
));

const CmdInput = React.forwardRef<
  HTMLInputElement,
  React.ComponentPropsWithoutRef<typeof CmdKPrimitive.Input>
>((props, forwardedRef) => (
  <CmdKPrimitive.Input className={styles.input} {...props} ref={forwardedRef} />
));

const CmdSeparator = React.forwardRef<
  HTMLDivElement,
  React.ComponentPropsWithoutRef<typeof CmdKPrimitive.Separator>
>((props, forwardedRef) => (
  <CmdKPrimitive.Separator
    className={sharedStyles.dropdownMenuSeparator}
    {...props}
    ref={forwardedRef}
  />
));

export const Command: CommandProps = Object.assign({
  ...CmdKPrimitive,
  Item: CmdItem,
  Input: CmdInput,
  Separator: CmdSeparator,
});
